import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { userState } from './state-accessors';

const authState = (state) => get(state, 'auth', {});

export const authTokenSelector = createSelector(authState, (auth) => !isEmpty(auth.token) && auth.token);

export const signedInUserSelector = createSelector(authTokenSelector, userState, (authToken, user) => {
  if (authToken && !isEmpty(user)) {
    return {
      ...user,
      isPhoneVerified: user.phoneStatus === 'verified',
    };
  } else return {};
});

export const isPreventedDetectingAuthUserSelector = createSelector(
  (state) => get(state, 'implicitAuth.isPrevented'),
  (state) => get(state, 'adminAuth.token'),
  (isPrevented, adminAuth) => isPrevented || adminAuth,
);

export const adminAuthSelector = createSelector(
  (state) => get(state, 'adminAuth', {}),
  (auth) => ({ ...auth, isSuperadmin: auth.role === 'Super Admin' }),
);

export const isSkippedSignInWithAuth0User = createSelector(
  (state) => get(state, 'auth0', {}),
  (state) => get(state, 'adminAuth.token'),
  (auth0, adminAuth) => {
    const { isSkipped, disabled } = auth0;

    return isSkipped || disabled || adminAuth;
  },
);

export const showConfirmNavigationModalSelector = createSelector(authState, (auth) =>
  get(auth, 'showConfirmNavigationModal', false),
);

export const isSuccessfulSignInSelector = createSelector(authState, (auth) => get(auth, 'successfulSignIn', false));

export const mfaChallengeSelector = createSelector(authState, (auth) => get(auth, 'mfaChallenge', null));
export const rememberMeSelector = createSelector(authState, (auth) => get(auth, 'rememberMe', false));
export const isMfaEnabledSelector = createSelector(signedInUserSelector, (user) => get(user, 'mfaEnabled', false));

export const detectingAuthenticatedUserSelector = createSelector(
  (state) => get(state, 'detectingAuthenticatedUser', {}),
  (detectingAuthenticatedUser) => detectingAuthenticatedUser,
);
